<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>

          <div class="KPIBlockDiv">
            <el-row :gutter="24">
              <el-col :xs="24" :sm="24" :md="8" :lg="8">
                <div class="block">
                  <h4>HELIX Activation %-Enterprise</h4>
                  <el-button
                    class="fr fullDivBtn"
                    size="mini"
                    type="text"
                    @click=""
                  >
                   <img src="~assets/img/btnIcon/icon_move.png">
                  </el-button>
                  <el-button
                    class="fr tableBtn"
                    size="mini"
                    type="text"
                    @click=""
                  >
                   <img src="~assets/img/btnIcon/icon_view report.png">
                  </el-button>
                  <div
                    class="echarts npPointer"
                    style="height: 200px"
                    id="EnterprisePie"
                  ></div>
                </div>
                <div class="block">
                  <h4>HELIX Activation</h4>
                  <el-button
                    class="fr fullDivBtn"
                    size="mini"
                    type="text"
                    @click=""
                  >
                   <img src="~assets/img/btnIcon/icon_move.png">
                  </el-button>
                  <el-button
                    class="fr tableBtn"
                    size="mini"
                    type="text"
                    @click=""
                  >
                   <img src="~assets/img/btnIcon/icon_view report.png">
                  </el-button>
                  <div
                    class="echarts npPointer"
                    style="height: 200px"
                    id="ActivationLine"
                  ></div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="8" :lg="8">
                <div class="block">
                  <h4>HELIX Active Service Due Notifications</h4>
                  <el-button
                    class="fr fullDivBtn"
                    size="mini"
                    type="text"
                    @click=""
                  >
                   <img src="~assets/img/btnIcon/icon_move.png">
                  </el-button>
                  <el-button
                    class="fr tableBtn"
                    size="mini"
                    type="text"
                    @click=""
                  >
                   <img src="~assets/img/btnIcon/icon_view report.png">
                  </el-button>
                  <span style="color: #cf554a">1.8<small>K</small></span>
                </div>
                <div class="block">
                  <h4>HELIX Shipments by Week</h4>
                   <el-button
                    class="fr fullDivBtn"
                    size="mini"
                    type="text"
                    @click=""
                  >
                   <img src="~assets/img/btnIcon/icon_move.png">
                  </el-button>
                  <el-button
                    class="fr tableBtn"
                    size="mini"
                    type="text"
                    @click=""
                  >
                   <img src="~assets/img/btnIcon/icon_view report.png">
                  </el-button>
                  <div
                    class="echarts npPointer"
                    style="height: 200px"
                    id="ShipWeekBar"
                  ></div>
                </div>
                <div class="block">
                  <h4>HELIX Activation2</h4>
                   <el-button
                    class="fr fullDivBtn"
                    size="mini"
                    type="text"
                    @click=""
                  >
                   <img src="~assets/img/btnIcon/icon_move.png">
                  </el-button>
                  <el-button
                    class="fr tableBtn"
                    size="mini"
                    type="text"
                    @click=""
                  >
                   <img src="~assets/img/btnIcon/icon_view report.png">
                  </el-button>
                  <span>61.2%</span>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="8" :lg="8">
                <div class="block">
                  <h4>HELIX Revenue Mode-Machine Overdue</h4>
                  <el-button
                    class="fr fullDivBtn"
                    size="mini"
                    type="text"
                    @click=""
                  >
                   <img src="~assets/img/btnIcon/icon_move.png">
                  </el-button>
                  <el-button
                    class="fr tableBtn"
                    size="mini"
                    type="text"
                    @click=""
                  >
                   <img src="~assets/img/btnIcon/icon_view report.png">
                  </el-button>
                  <span style="color: #fcbc5d"><small>$</small>15,282,175</span>
                </div>
                <div class="block">
                  <h4>HELIX Machines Due for Service</h4>
                <el-button
                    class="fr fullDivBtn"
                    size="mini"
                    type="text"
                    @click=""
                  >
                   <img src="~assets/img/btnIcon/icon_move.png">
                  </el-button>
                  <el-button
                    class="fr tableBtn"
                    size="mini"
                    type="text"
                    @click=""
                  >
                   <img src="~assets/img/btnIcon/icon_view report.png">
                  </el-button>
                  <span>528</span>
                </div>
                <div class="block">
                  <h4>Weekly HELIX Alerts Messages</h4>
                 <el-button
                    class="fr fullDivBtn"
                    size="mini"
                    type="text"
                    @click=""
                  >
                   <img src="~assets/img/btnIcon/icon_move.png">
                  </el-button>
                  <el-button
                    class="fr tableBtn"
                    size="mini"
                    type="text"
                    @click=""
                  >
                   <img src="~assets/img/btnIcon/icon_view report.png">
                  </el-button>
                  <div
                    class="echarts npPointer"
                    style="height: 200px"
                    id="WeekAlertMsgBar"
                  ></div>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-main>
      </el-scrollbar>
    </el-container>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { GetKPIStat, getCustomerRegionTable } from "../../api/api";
export default {
  name: "index",

  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
    }),
  },
  data() {
    return {};
  },

  mounted() {},
  methods: {
    initEnterprisePie() {
      var EnterprisePie = this.$echarts.init(
        document.getElementById("EnterprisePie")
      );
      var Data = [
        { name: "Active", value: 2051 },
        { name: "Inactive", value: 1449 },
      ];
      var All = Data[0].value + Data[1].value;
      var optionEnterprisePie = {
        tooltip: {
          show: false,
        },
        legend: {
          left: "55%",
          top: 40,
          icon: "circle",
          orient: "vertical",
          itemGap: 40,
          formatter: (name) => {
            return (
              "{name|" +
              name +
              "}\n{num|" +
              (
                Data.find((item) => {
                  return item.name == name;
                }).value / 1000
              ).toFixed(1) +
              "K} {percent| ( " +
              (
                (Data.find((item) => {
                  return item.name == name;
                }).value *
                  100) /
                All
              ).toFixed(1) +
              "% )" +
              "}"
            );
          },
          textStyle: {
            rich: {
              name: {
                color: "#828393",
                fontSize: 12,
                fontFamily: "Arial, 'microsoft yahei'",
                align: "left",
                padding: [30, 0, 10, 0],
              },
              num: {
                color: "#fff",
                fontSize: 18,
                fontFamily: "Arial, 'microsoft yahei'",
                align: "left",
              },
              percent: {
                color: "#fff",
                fontSize: 12,
                fontWeight: "normal",
                fontFamily: "Arial, 'microsoft yahei'",
                align: "left",
                verticalAlign: "middle",
              },
            },
          },
        },
        series: [
          {
            name: "circle",
            type: "pie",
            clockWise: true,
            center: ["26%", "55%"],
            radius: ["60%", "78%"],
            hoverAnimation: false,
            cursor: "default",
            data: [
              {
                value: Data[0].value,
                name: "Active",
                label: {
                  position: "center",
                  formatter: "{c}K",
                  color: "#fff",
                  fontSize: 24,
                  fontWeight: "bold",
                  fontFamily: "Arial",
                },
                labelLine: {
                  show: false,
                },
                itemStyle: {
                  normal: {
                    color: "#28739A",
                  },
                },
                tooltip: {
                  show: false,
                },
              },
              {
                name: "Inactive",
                value: Data[1].value,
                itemStyle: {
                  normal: {
                    color: "#51A470",
                  },
                },
                label: {
                 
                    show: false,
                 
                },
                labelLine: {
                  show: false,
                  length: 0,
                  length2: 0,
                },
                tooltip: {
                  show: false,
                },
              },
            ],
          },
        ],
      };
      EnterprisePie.setOption(optionEnterprisePie);

      window.addEventListener("resize", () => {
        EnterprisePie.resize();
      });
    },
    initActivationLine() {
      var ActivationLine = this.$echarts.init(
        document.getElementById("ActivationLine")
      );
      var Data = [52, 32, 78, 47, 61, 29];
      var TimeData = [
        "2021-4",
        "2021-5",
        "2021-6",
        "2021-7",
        "2021-8",
        "2021-9",
      ];
      var optionActivationLine = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0] / 2 - 50, point[1] - 100];
          },
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#828393",
            fontSize: 10,
            fontFamily: "Arial",
          },
        },
        grid: {
          top: 30,
          left: 35,
          right: 5,
          bottom: 20,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          // boundaryGap: false,
          data: TimeData,
        },
        yAxis: {
          type: "value",
          splitNumber: 5,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#3A3D46",
            },
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
            formatter: function (value, index) {
              return value + "%";
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          max: 100,
        },
        series: [
          {
            name: "Registration Number ",
            type: "line",
            cursor: "default",
            smooth: true, //是否平滑
            showAllSymbol: false,
            symbol: "circle",
            symbolSize: 5,
            lineStyle: {
              normal: {
                color: "rgba(255,255,255,1)",
              },
            },
            itemStyle: {
              color: "rgba(58,64,73,1)",
              borderColor: "rgba(255,255,255,1)",
              borderWidth: 1,
            },
            emphasis: {
              cursor: "default",
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(255,255,255,0.5)" },
                  { offset: 0.9, color: "rgba(255,255,255,0)" },
                  { offset: 1, color: "rgba(255,255,255,0)" },
                ]),
              },
            },
            data: Data,
          },
        ],
      };
      ActivationLine.setOption(optionActivationLine);

      window.addEventListener("resize", () => {
        ActivationLine.resize();
      });
    },
    initShipWeekBar() {
      var ShipWeekBar = this.$echarts.init(
        document.getElementById("ShipWeekBar")
      );
      var ColorList = ["#28739A", "#51A470"];
      var Data = [
        {
          name: "Active",
          value: [20, 30, 32, 25, 45, 37, 32, 60, 48, 12],
        },
        {
          name: "Inactive",
          value: [5, 8, 18, 10, 24, 10, 3, 30, 4, 5, 16, 2],
        },
      ];
      var TimeData = [
        "08-02  ~  08-08",
        "08-09  ~  08-15",
        "08-16  ~  08-22",
        "08-23  ~  08-29",
        "08-30  ~  08-29",
        "09-06  ~  09-12",
        "09-13  ~  09-19",
        "09-20  ~  09-26",
        "09-27  ~  10-04",
        "10-04  ~  10-11",
      ];
      var series = [];
      for (let i = 0; i < Data.length; i++) {
        var seriesTemp = {
          name: Data[i].name,
          type: "bar",
          barWidth: "80%",
          data: Data[i].value,
          stack: "all",
          label: {
            show: false,
          },
          itemStyle: {
            normal: {
              color: ColorList[i],
            },
          },
        };
        series.push(seriesTemp);
      }
      var optionShipWeekBar = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0] - 80, point[1] - 100];
          },
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#828393",
            fontSize: 10,
            fontFamily: "Arial",
          },
        },
        grid: {
          top: 30,
          left: 35,
          right: 5,
          bottom: 50,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              margin: 5,
              color: "#828393",
              fontSize: 10,
              fontFamily: "Arial",
              lineHeight: 12,
            },
            formatter: function (params) {
              var newParamsName = ""; // 最终拼接成的字符串
              var paramsNameNumber = params.length; // 实际标签的个数
              var provideNumber = 5; // 每行能显示的字的个数
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
              /**
               * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
               */
              // 条件等同于rowNumber>1
              if (paramsNameNumber > provideNumber) {
                /** 循环每一行,p表示行 */
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = ""; // 表示每一次截取的字符串
                  var start = p * provideNumber; // 开始截取的位置
                  var end = start + provideNumber; // 结束截取的位置
                  // 此处特殊处理最后一行的索引值
                  if (p == rowNumber - 1) {
                    // 最后一次不换行
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    // 每一次拼接字符串并换行
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr; // 最终拼成的字符串
                }
              } else {
                // 将旧标签的值赋给新标签
                newParamsName = params;
              }
              //将最终的字符串返回
              return newParamsName;
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          // boundaryGap: false,
          data: TimeData,
        },
        yAxis: {
          type: "value",
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#3A3D46",
            },
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: series,
      };
      ShipWeekBar.setOption(optionShipWeekBar);

      window.addEventListener("resize", () => {
        ShipWeekBar.resize();
      });
    },
    initWeekAlertMsgBar() {
      var WeekAlertMsgBar = this.$echarts.init(
        document.getElementById("WeekAlertMsgBar")
      );
      var ColorList = [
        "#28739A",
        "#51A470",
        "#CF554A",
        "#FCBC5D",
        "#4A6AB5",
        "#4AA4CF",
      ];
      var Data = [
        {
          name: "0.0",
          value: [200, 200, 200, 200, 200],
        },
        {
          name: "7.0",
          value: [150, 123, 158, 215, 120],
        },
        {
          name: "A600 Service Due",
          value: [180, 50, 45, 16, 82],
        },
        {
          name: "A501 Discharge Over",
          value: [20, 56, 190, 42, 12],
        },
         {
          name: "A501 Discharge",
          value: [215,0,318,152,235],
        },
      ];
      var TimeData = [ 
        "09-06  ~  09-12",
        "09-13  ~  09-19",
        "09-20  ~  09-26",
        "09-27  ~  10-04",
        "10-04  ~  10-11",
      ];
      var series = [];
      for (let i = 0; i < Data.length; i++) {
        var seriesTemp = {
          name: Data[i].name,
          type: "bar",
          barWidth: "80%",
          data: Data[i].value,
          stack: "all",
          label: {
            show: false,
          },
          itemStyle: {
            normal: {
              color: ColorList[i],
            },
          },
        };
        series.push(seriesTemp);
      }
      var optionWeekAlertMsgBar = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
           return [point[0] - 150, point[1] - 200];
          },
          // position:"top",
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#828393",
            fontSize: 10,
            fontFamily: "Arial",
          },
        },
        grid: {
          top: 30,
          left: 35,
          right: 5,
          bottom: 50,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              margin: 5,
              color: "#828393",
              fontSize: 10,
              fontFamily: "Arial",
              lineHeight: 12,
            },
            formatter: function (params) {
              var newParamsName = ""; // 最终拼接成的字符串
              var paramsNameNumber = params.length; // 实际标签的个数
              var provideNumber = 5; // 每行能显示的字的个数
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
              /**
               * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
               */
              // 条件等同于rowNumber>1
              if (paramsNameNumber > provideNumber) {
                /** 循环每一行,p表示行 */
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = ""; // 表示每一次截取的字符串
                  var start = p * provideNumber; // 开始截取的位置
                  var end = start + provideNumber; // 结束截取的位置
                  // 此处特殊处理最后一行的索引值
                  if (p == rowNumber - 1) {
                    // 最后一次不换行
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    // 每一次拼接字符串并换行
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr; // 最终拼成的字符串
                }
              } else {
                // 将旧标签的值赋给新标签
                newParamsName = params;
              }
              //将最终的字符串返回
              return newParamsName;
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          // boundaryGap: false,
          data: TimeData,
        },
        yAxis: {
          type: "value",
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#3A3D46",
            },
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: series,
      };
      WeekAlertMsgBar.setOption(optionWeekAlertMsgBar);

      window.addEventListener("resize", () => {
        WeekAlertMsgBar.resize();
      });
    },
  },
  created() {
    var _self = this;
    this.$nextTick(() => {
      _self.initEnterprisePie();
      _self.initActivationLine();
      _self.initShipWeekBar();
      _self.initWeekAlertMsgBar();
    });
  },
};
</script>


